import { createEffect } from 'effector'
import { APIResult, AxiosError } from '../../core/api/Result'
import { GetProjectReq, ProjectAPI, GetProjectSectionsReq, GetProjectHistoryReq } from '../../services/api/Project'

export const getProjectsFx = createEffect<unknown, APIResult<typeof ProjectAPI['getProjects']>, AxiosError>(
  ProjectAPI.getProjects,
)

export const getProjectFx = createEffect<GetProjectReq, APIResult<typeof ProjectAPI['getProject']>, AxiosError>(
  ProjectAPI.getProject,
)

export const getProjectSectionsFx = createEffect<GetProjectSectionsReq, APIResult<typeof ProjectAPI['getProjectSections']>, AxiosError>(
  ProjectAPI.getProjectSections,
)

export const getProjectHistoryFx = createEffect<GetProjectHistoryReq, APIResult<typeof ProjectAPI['getProjectHistory']>, AxiosError>(
  ProjectAPI.getProjectHistory,
)

export const getProjectAnnualHistoryFx = createEffect<{ symbol: string }, APIResult<typeof ProjectAPI['getProjectHistory']>, AxiosError>(
  ({ symbol }) => ProjectAPI.getProjectHistory({ symbol, step: 'year', limit: 5 }),
)
